import React, { useState, useRef, useEffect } from 'react';
import { NavLink, Outlet, useNavigate, useParams } from 'react-router-dom';
import { useCollection } from './hooks/useCollection';

const tabs = [
  { to: 'overview', label: 'Overview' },
  { to: 'artworks', label: 'Artworks' },
  { to: 'artists', label: 'Artists' },
  { to: 'judging', label: 'Judging' },
  { to: 'communications', label: 'Communications' },
  { to: 'event', label: 'Event' },
  { to: 'submissions', label: 'Submissions' },
  { to: 'acceptances', label: 'Acceptances' },
  { to: 'display-cards', label: 'Display Cards' },
  { to: 'wall-planner', label: 'Wall Planner' },
  { to: 'wall-planner-3d', label: '3D Wall Planner' }
];

export default function CuratorCollectionLayout() {
  const { collectionId } = useParams();
  const { data: collection, loading } = useCollection(collectionId);
  const navigate = useNavigate();
  const [actionsOpen, setActionsOpen] = useState(false);
  const actionsRef = useRef(null);

  useEffect(() => {
    const onClickAway = (e) => {
      if (actionsRef.current && !actionsRef.current.contains(e.target)) {
        setActionsOpen(false);
      }
    };
    document.addEventListener('click', onClickAway);
    return () => document.removeEventListener('click', onClickAway);
  }, []);

  const goLegacyAdmin = () => navigate(`/curator/collections/${collectionId}`);
  const goDisplayCards = () => navigate(`/printReactCards/${collectionId}`);
  const goWallPlanner = () => navigate(`/gallery-wall-planner/${collectionId}`);
  const doRefresh = () => window.location.reload();

  return (
    <div className="curator-collection-layout">
      <header className="curator-collection-header">
        <div className="header-left">
          <h1 className="title">{collection?.title || 'Collection'}</h1>
          <p className="subtitle">{collection?.description || 'Manage everything for this collection'}</p>
        </div>
        <div className="header-right" ref={actionsRef}>
          <button className="btn-primary" onClick={() => setActionsOpen((o) => !o)}>Actions</button>
          {actionsOpen && (
            <div className="dropdown-menu">
              <button className="dropdown-item" onClick={doRefresh}>Refresh</button>
              <button className="dropdown-item" onClick={goLegacyAdmin}>Open Legacy Admin</button>
              <div className="dropdown-sep" />
              <button className="dropdown-item" onClick={goDisplayCards}>Display Cards</button>
              <button className="dropdown-item" onClick={goWallPlanner}>Wall Planner (2D)</button>
            </div>
          )}
        </div>
      </header>

      <nav className="curator-collection-tabs">
        {tabs.map((t) => (
          <NavLink key={t.to} to={t.to} className={({ isActive }) => isActive ? 'tab active' : 'tab'}>
            {t.label}
          </NavLink>
        ))}
      </nav>

      <main className="curator-collection-content">
        <Outlet context={{ collectionId, collection }} />
      </main>
    </div>
  );
}
